import { CHAT_QUERY_KEYS, chatQueryKeys } from '@photon/chat-core';

const QUERYKEYS = {
  ...CHAT_QUERY_KEYS,
  PENDING_APPROVALS: "pendingApprovals",
  GET_ALL_MODELS: "GET_ALL_MODELS",
  UPDATE_MODEL: "UPDATE_MODEL",
  UPDATE_MODEL_DEFAULTS: "UPDATE_MODEL_DEFAULTS",
  GET_MODEL_PROVIDER: "GET_MODEL_PROVIDER",
  UPDATE_MODEL_PROVIDER: "UPDATE_MODEL_PROVIDER",
  DELETE_MODEL_PROVIDER: "DELETE_MODEL_PROVIDER",
  LIST_MODEL_PROVIDERS: "LIST_MODEL_PROVIDERS",
  CREATE_SPECTRA: "CREATE_SPECTRA",
  SPECTRA_DETAILS: "SPECTRA_DETAILS",
  DELETE_SPECTRA: "DELETE_SPECTRA",
  LEAVE_SPECTRA: "LEAVE_SPECTRA",
  MOVE_CHAT: "MOVE_CHAT",
  EDIT_SPECTRA: "EDIT_SPECTRA",
  UPDATE_SPARK_TITLE: "UPDATE_SPARK_TITLE",
  DELETE_MESSAGE: "DELETE_MESSAGE",
  ADD_COLLABORATOR: "ADD_COLLABORATOR",
  REMOVE_COLLABORATOR: "REMOVE_COLLABORATOR",
  SET_CHAT_MODEL: "SET_CHAT_MODEL",
  GET_FILE_DATA: "GET_FILE_DATA",
  QUANTUM_AGENT_BUILD: "QUANTUM_AGENT_BUILD",
  QUANTUM_AGENT_CALL: "QUANTUM_AGENT_CALL",
  QUANTUM_AGENT_BUILD_DETAILS: "QUANTUM_AGENT_BUILD_DETAILS",
  QUANTUM_AGENT_GET_TOOLS: "QUANTUM_AGENT_GET_TOOLS",
  GET_WORKSPACE_DETAILS: "GET_WORKSPACE_DETAILS",
  DELETE_ALL_SPARKS: "DELETE_ALL_SPARKS",
  INITANALYSISMESSAGE: "INITANALYSISMESSAGE",
  LIST_AGENTS: "LIST_AGENTS",
  // Scheduler
  LIST_SCHEDULER_JOBS: "LIST_SCHEDULER_JOBS",
  CREATE_SCHEDULER_JOB: "CREATE_SCHEDULER_JOB",
  UPDATE_SCHEDULER_JOB: "UPDATE_SCHEDULER_JOB",
  DELETE_SCHEDULER_JOB: "DELETE_SCHEDULER_JOB",
  LIST_ADMIN_SCHEDULER_JOBS: "LIST_ADMIN_SCHEDULER_JOBS",
  CREATE_MODEL: "CREATE_MODEL",
  DELETE_MODEL: "DELETE_MODEL",
  // Admin FinOps & Audit
  ADMIN_FINOPS_SUMMARY: "ADMIN_FINOPS_SUMMARY",
  ADMIN_AUDIT_LOG: "ADMIN_AUDIT_LOG",
  // Skills
  INSTALL_SKILL: "INSTALL_SKILL",
  UPDATE_SKILL: "UPDATE_SKILL",
  REMOVE_SKILL: "REMOVE_SKILL",
  PREVIEW_SKILL: "PREVIEW_SKILL",
  GET_SKILL_MD: "GET_SKILL_MD",
  GET_SKILL_CREDENTIAL: "GET_SKILL_CREDENTIAL",
  SAVE_SKILL_CREDENTIAL: "SAVE_SKILL_CREDENTIAL",
  // Persistent Memory
  GET_PERSISTENT_MEMORY: "GET_PERSISTENT_MEMORY",
  // Artifact Versioning
  ARTIFACT_VERSIONS: "ARTIFACT_VERSIONS",
};

export const chatModelInfoQueryKey = chatQueryKeys.modelInfo;

export default QUERYKEYS;
